import styled, { css } from "styled-components";
import { ReactSVG } from "react-svg";

export const Container = styled.div`
  max-width: 90%;
  margin: 0 auto;
`;

export const Card = styled.div`
  background: #fff;
  li {
    list-style: none;
  }
  .last {
    border: none;
  }
`;

export const CardHeader = styled.div`
  padding: 0.2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: solid 2px #bbbbbb;

  ${({ theme }) => css`
    .border {
      padding: 10px;
      color: ${theme.colors.gray};
      font-size: 1.3rem;
      width: 37%;
      height: auto;
      text-align: center;
    }
  `}

  @media only screen and (max-width: 500px) {
    .border {
      padding: 0;
      text-align: center;
      width: 44%;
    }

    span {
      font-size: 1.2rem;
    }
  }

  @media (min-width: 1600px) {
    .border {
      width: 35%;
    }
  }
`;

export const CardBody = styled.div`
  width: 100%;
  padding: 0;
`;

export const SvgIcon = styled(ReactSVG)`
  margin-right: 2rem;
  position: relative;
  top: 0.7rem;
  left: 1rem;
  fill: #00a2e0 !important;
  display: flex;
  justify-content: center;
  cursor: pointer;
`;

export const SvgIconInvert = styled(ReactSVG)`
  width: 2.5rem;
  fill: #ffffff !important;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SvgIconDisabled = styled(ReactSVG)`
  margin-right: 2rem;
  width: 3rem;
  height: 35.2px;
  margin: 4px 25.4px 4.6px 0;
  fill: #cccccc !important;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  padding-bottom: 40px;
`;

export const SelectContainer = styled.div``;

export const RodaPe = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  margin-top: -40px;
`;

export const SelectPaginacaoWrapper = styled.div`
  width: 70%;
`;

// export const GoTopoButtonWrapper = styled.div`
//   display: flex;
//   justify-content: flex-end;
//   padding: 20px 0;
// `;
